import { h } from 'preact';
export const IconCheckmark = function() {
    return h('svg', {
        width: '10',
        height: '10',
        viewBox: '0 0 10 10',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        className: 'wishlist__add-to-list-checkbox-checkmark',
        'aria-hidden': 'true'
    }, [
        h('path', {
            d: 'M1.09814 5.47343L3.7498 8.12508L9.0531 2.82178',
            stroke: 'white',
            'stroke-width': '1.5',
            'stroke-linejoin': 'round'
        })
    ]);
};
